import { RISK_LOWER_THRESHOLD, RISK_UPPER_THRESHOLD } from '@/constants/risks';
import { formatRiskDecimal } from './format-risk-decimal';

export const colorFromRisk = (
  risk: number,
  averageRisk: number
): {
  color: string;
  backgroundColor: string;
  textColor: string;
} => {
  const riskPercentage = parseFloat(formatRiskDecimal(risk));
  const averageRiskPercentage = parseFloat(formatRiskDecimal(averageRisk));

  if (riskPercentage > averageRiskPercentage * RISK_UPPER_THRESHOLD) {
    return { color: 'alert-error-default', backgroundColor: 'alert-error-default', textColor: 'text-error' };
  } else if (riskPercentage < averageRiskPercentage * RISK_LOWER_THRESHOLD) {
    return { color: 'alert-success-default', backgroundColor: 'alert-success-default', textColor: 'black' };
  } else {
    return { color: 'tan', backgroundColor: 'tan', textColor: 'black' };
  }
};
